import React from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Icon from "Components/Icons/Icon";

interface Attachment {
  id: number;
  type: string;
  url: string;
}

interface AttachmentsListProps {
  attachments: Attachment[];
  onDelete: (id: number) => void;
  onView?: (url: string) => void;
}

const AttachmentsList: React.FC<AttachmentsListProps> = ({
  attachments,
  onDelete,
  onView,
}) => {
  if (!attachments || attachments.length === 0) return null;

  const handleView = (url: string) => {
    if (onView) onView(url);
    else window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="my-3 row g-2">
      {attachments.map((item) => (
        <div key={item.id} className="col-12 col-sm-6 col-md-4 mb-1">
          <div className="d-flex p-2 align-items-center justify-content-between br-7 dashed m-0">
            <div className="d-flex align-items-center gap-2">
              <div
                className="bg-greyF5"
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="Link" />
              </div>

              <div className="fw-normal fs-14 text-grey89">
                {String(item.id).toUpperCase()} Asset.{item.type}
              </div>
            </div>

            <UncontrolledDropdown>
              <DropdownToggle
                className="btn btn-sm dropdown"
                tag="button"
                type="button"
              >
                <i className="ri-more-fill align-middle"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  type="button"
                  tag="span"
                  onClick={() => handleView(item.url)}
                >
                  <i className="ri-eye-fill me-2 text-muted"></i> View
                </DropdownItem>

                <DropdownItem
                  type="button"
                  tag="span"
                  onClick={() => onDelete(Number(item.id))}
                >
                  <i className="ri-delete-bin-6-fill me-2 text-muted"></i>
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(AttachmentsList);
